import { AgTechWebApplicationInfo } from "@agtech/web/application/AgTechWebApplication";
import AgTechSideNavigationMenu from "@agtech/web/components/App/Templates/App/Navigation/Controls/AgTechSideNavigationMenu";
import SaleSelectionDropdown from "../areas/sales/components/dropdowns/SaleSelectionDropdown";
import AgTechSideNavigationButton from "@agtech/web/components/App/Templates/App/Navigation/Controls/AgTechSideNavigationButton";
import SaleContactMasterDetailDialog from "../areas/contacts/dialogs/master/SaleContactMasterDetailDialog";
import SaleSettingsViewDialog from "../areas/sales/dialogs/SaleSettingsViewDialog";
import OperationSideNavigationInfo from "@agtech/web/integrations/operation/info/OperationSideNavigationInfo";
import ReportsDialog from "../areas/reports/dialogs/ReportsDialog";
import MyPlanningTasksDialog from "../areas/planningTasks/dialogs/MyPlanningTasksDialog";
import { AgTechTourConfig } from "@agtech/web/components/App/Tour/AgTechTourTypes";

export type SalesAppSideNavigationMenuProps = {
    app: AgTechWebApplicationInfo
    tourConfig?: AgTechTourConfig
}

const SalesAppSideNavigationMenu = (props: SalesAppSideNavigationMenuProps) => {
    return (
        <div id="sales-sidebar" className="tall flex">
            <AgTechSideNavigationMenu
                app={props.app}
                width="w-[280px]"
                tourConfig={props.tourConfig}
                content={isCollapsed => (
                    <>
                        {!isCollapsed && (
                            <div id="sales-sale-selector" className="row-based p-6 bg-slate-700 border-b border-t border-slate-600 flex">
                                <OperationSideNavigationInfo />
                                <SaleSelectionDropdown classes="mt-8" />
                            </div>
                        )}
                        <div className="row-based flexed pt-6 pb-2 flex">
                            <div className="mt-6 mb-2 row-based flex">
                                <div id="sales-contacts-button">
                                    <AgTechSideNavigationButton
                                        {...SaleContactMasterDetailDialog.ButtonProps()}
                                        isCollapsed={isCollapsed}
                                    />
                                </div>
                                {/*<AgTechSideNavigationButton
                                    {...SaleHistoryViewDialog.ButtonProps}
                                    role={'Admin'}
                                    isCollapsed={isCollapsed}
                                />*/}
                                <div id="sales-my-tasks-button">
                                    <AgTechSideNavigationButton
                                        {...MyPlanningTasksDialog.ButtonProps()}
                                        isCollapsed={isCollapsed}
                                    />
                                </div>
                                <div id="sales-reports-button">
                                    <AgTechSideNavigationButton
                                        {...ReportsDialog.ButtonProps}
                                        permission="reports.view"
                                        isCollapsed={isCollapsed}
                                    />
                                </div>
                                <div id="sales-settings-button">
                                    <AgTechSideNavigationButton
                                        {...SaleSettingsViewDialog.ButtonProps}
                                        permission="operation.settings"
                                        isCollapsed={isCollapsed}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            />
        </div>
    );
}

export default SalesAppSideNavigationMenu;